import React__default from 'react';
import { createPortal } from 'react-dom';
import '../../node_modules/classnames/index.esm.js';

const DialogPortal = ({
  children
}) => {
  return /*#__PURE__*/createPortal(children, document.body);
};
const DialogOverlay = ({
  children
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "voyage-dialog__overlay animate-fade-in"
  }, children);
};

export { DialogOverlay, DialogPortal };
//# sourceMappingURL=dialog.esm.js.map
